import React, { useEffect } from 'react'
import { formatMessageNew } from '@/utils/common'
import LoginLayout from '@/pages/AndroidDevice/login/loginLayout'
const channelOptions = [
  {
    label: () => formatMessageNew('languageObj.qrCode.fullBindingTitle1025'),
    labelType: 'function',
    value: '1025 FULL',
    type: 'NFC FULL Bind',
    router: '/rf/fulltag'
  },
  {
    label: () => formatMessageNew('languageObj.qrCode.nddcBindingTitle1025'),
    labelType: 'function',
    value: '1025 NDDC',
    type: 'NFC NDDC Bind',
    router: '/rf/nddctag'
  },
  {
    label: () => formatMessageNew('languageObj.qrCode.fullBindingTitle1027'),
    labelType: 'function',
    value: '1027 FULL',
    type: 'NFC FULL Bind',
    router: '/rf/fulltag'
  },
  {
    label: () => formatMessageNew('languageObj.qrCode.nddcBindingTitle1027'),
    labelType: 'function',
    value: '1027 NDDC',
    type: 'NFC NDDC Bind',
    router: '/rf/nddctag'
  }
]
const bindingOptions = [
  {
    label: () => formatMessageNew('languageObj.qrCode.bindingTitle'),
    labelType: 'function',
    value: 'RFID',
    type: 'RFID NDDC Bind',
    router: '/qr/binding'
  }
]
const unbindByCartonOptions = [
  {
    label: () => formatMessageNew('languageObj.qrCode.unbindByCartonTitle'),
    labelType: 'function',
    value: 'RFID',
    type: 'RFID NDDC Unbind (by Carton)',
    router: '/qr/unbind/by/carton'
  },
  {
    label: () => formatMessageNew('languageObj.qrCode.unbindByPieceTitle'),
    labelType: 'function',
    value: 'RFID',
    type: 'RFID NDDC Unbind (by Piece)',
    router: '/qr/unbind/by/piece'
  },
  {
    label: () => formatMessageNew('languageObj.qrCode.unbindBySoTitle'),
    labelType: 'function',
    value: 'RFID',
    type: 'RFID NDDC Unbind (by SO)',
    router: '/qr/unbind/by/so'
  }
]
const reprintOptions = [
  {
    label: () => formatMessageNew('languageObj.reprint.reprintTitle'),
    labelType: 'function',
    value: 'reprint',
    type: '',
    router: '/rf/reprint/print'
  }
]
const RFIDScanOptions = [
  {
    label: () => formatMessageNew('languageObj.qrCode.rfIbScanningTitle1025'),
    labelCode: 'rfIbScanningTitle1025',
    labelType: 'function',
    value: '1025 FULL',
    type: '1025 RFID Carton Scan - Inbound',
    plant: '1025',
    businessType: 1,
    router: '/qr/rfIdScan'
  },
  {
    label: () => formatMessageNew('languageObj.qrCode.rfObScanningTitle1025'),
    labelCode: 'rfObScanningTitle1025',
    labelType: 'function',
    value: '1025 NDDC',
    type: '1025 RFID Carton Scan - Outbound',
    plant: '1025',
    businessType: 2,
    router: '/qr/rfIdScan'
  },
  {
    label: () => formatMessageNew('languageObj.qrCode.rfIbScanningTitle1027'),
    labelCode: 'rfIbScanningTitle1027',
    labelType: 'function',
    value: '1027 FULL',
    type: '1027 RFID Carton Scan - Inbound',
    plant: '1027',
    businessType: 1,
    router: '/qr/rfIdScan'
  },
  {
    label: () => formatMessageNew('languageObj.qrCode.rfObScanningTitle1027'),
    labelCode: 'rfObScanningTitle1027',
    labelType: 'function',
    value: '1027 NDDC',
    type: '1027 RFID Carton Scan - Outbound',
    plant: '1027',
    businessType: 2,
    router: '/qr/rfIdScan'
  }
]
const skuCheckOptions = [
  {
    label: () => formatMessageNew('languageObj.reprint.rifdSkuCheck'),
    labelType: 'function',
    value: 'reprint',
    type: '',
    router: '/rf/rfidskucheckhoneywell'
  }
]
const PhoneTagLogin = () => {
  useEffect(() => {
    // 1: 正常登录，2：mac地址登录
    localStorage.setItem('nfc-auth-type', '2')
    localStorage.setItem('qrLogin', '/rf/login')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <div>
      <LoginLayout
        channelArr={[
          ...channelOptions,
          ...bindingOptions,
          ...unbindByCartonOptions,
          ...reprintOptions,
          ...RFIDScanOptions,
          ...skuCheckOptions
        ]}
      />
    </div>
  )
}

export default PhoneTagLogin
